export const contentTypes = {
    CfCampaignBanner: 'home_banner',
    CfDiscountBanner: 'discountMessageBar',
    CfGPageDefaultCta: 'lpDefaultCta',
    CfGPageCustomerSupportCta: 'lpCustomerSupportCta',
    CfGPageMarketingCard: 'lpMarketingCard',
    CfGPageMediaObject: 'lpMediaObject',
    CfGPageTextBlock: 'lpTextBlock',
    CfGPageCarousel: 'lpCarousel',
    CfGPageColumn: 'lpColumn',
    CfGPageCostComparison: 'lpCostComparison',
    CfGPageFaqWidget: 'faqAndContactWidget',
    CfGPageFloatingText: 'lpFloatingText',
    CfGPageHandPickedProduct: 'lpHandPickedProduct',
    CfGPageMarkdown: 'lpMarkdown',
    CfGPagePageTopper: 'lpPageTopper',
    CfGPageProductList: 'lpProductList',
    CfGPageRelatedProducts: 'lpRelatedProducts',
    CfGPageRichText: 'richText',
    CfGPageTrendingProducts: 'lpTrendingProducts',
    CfLink: 'simple_link',
    CfMarketingBlock: 'marketingBlock',
    CfPressItem: 'press_item',
    CfProductAccessory: 'productAccessory',
    CfUspCard: 'usp_card',
    CfContentPage: 'contentPage',
    CfFaqWidget: 'faq_widget',
    CfBusinessLandingPage: 'business_landing_page',
    CfGPage: 'landingPage',
    CfHomePage: 'home_page',
    CfHomePromoPage: 'homepage',
    CfListingPage: 'listingPage',
    CfListingPageSeoBlock: 'listingPageSeoBlock',
    CfProductDetailPage: 'pdpMarketingMaterials',
    CfPartnerProductPage: 'partnersLandingPage',
    CfHowItWorksPage: 'howItWorksPage',
    CfMarketingCard: 'widgetFeedMarketing',
    CfGPageHeroVideo: 'heroVideo',
    CfGPageColorBlock: 'colorBlock',
    CfUspCardsWidget: 'uspCardsWidget',
    CfGPageTestimonialWidget: 'testimonialWidget',
    CfBlackFridayContent: 'blackFridayContent',
    CfGPageCountdown: 'countdown',
    CfGPageLeadForm: 'leadForm',
};
